import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '8x8x水蜜桃',
  url: 'https://8x8xpeach.com',
  description: '热门内容平台，提供丰富视频资源和内容服务',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://8x8xpeach.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="官方落地页——甜蜜体验全攻略"
        description="8x8x水蜜桃是备受关注的热门内容平台入口，提供最新资源、使用指南、安全访问方式及常见问题解答。水蜜桃视频平台助您快速找到所需内容，畅享极致体验。"
        keywords="8x8x水蜜桃,8x8x水蜜桃最新地址,8x8x水蜜桃入口,8x8x水蜜桃官网,水蜜桃视频平台,8x8x最新版,水蜜桃免费资源"
        canonicalUrl="https://8x8xpeach.com/"
        schema={[homeSchema]}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategorySection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}